import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/logo-pam-immo.png" 
                alt="PAM IMMO SERVICES" 
                className="h-10 w-auto object-contain"
              />
              <div>
                <h3 className="text-xl font-bold text-amber-400">{companyInfo.name}</h3>
                <p className="text-sm text-slate-300">{companyInfo.slogan}</p>
              </div>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed">
              Votre partenaire de confiance pour tous vos projets immobiliers au Sénégal.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Liens rapides</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-slate-300 hover:text-amber-400 transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-slate-300 hover:text-amber-400 transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-slate-300 hover:text-amber-400 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/villas" className="text-sm text-slate-300 hover:text-amber-400 transition-colors">
                  Villas
                </Link>
              </li>
              <li>
                <Link to="/terrains" className="text-sm text-slate-300 hover:text-amber-400 transition-colors">
                  Terrains
                </Link>
              </li>
              <li>
                <Link to="/appartements" className="text-sm text-slate-300 hover:text-amber-400 transition-colors">
                  Appartements
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-sm text-slate-300 hover:text-amber-400 transition-colors">
                  Nos Projets
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-slate-300 hover:text-amber-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Nos Services</h4>
            <ul className="space-y-2 text-sm text-slate-300">
              <li>Vente de Terrains</li>
              <li>Vente Immobilière</li>
              <li>Construction</li>
              <li>Gérance Immobilière</li>
              <li>Terrassement</li>
              <li>Lotissement</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-center gap-2 text-sm text-slate-300 hover:text-amber-400 transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  {companyInfo.phone}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${companyInfo.phone2}`}
                  className="flex items-center gap-2 text-sm text-slate-300 hover:text-amber-400 transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  {companyInfo.phone2}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-2 text-sm text-slate-300 hover:text-amber-400 transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2 text-sm text-slate-300">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                {companyInfo.address}
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex gap-3 mt-4">
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center hover:bg-amber-600 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center hover:bg-amber-600 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center hover:bg-amber-600 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400">
          <p>© {currentYear} {companyInfo.name}. Tous droits réservés.</p>
          <p className="text-amber-400 font-medium">
            Site conçu et développé par POWER DIGITALISATION
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;